import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { CaseData } from '../../apis/inventoryCase.api'
import Card from '../../components/Card'
import PageHeading from '../../components/PageHeading'
import RadioGroup, { RadioGroupItem } from '../../components/RadioGroup'
import TransferToCase from './TransferToCase'
import TransferToProduction from './TransferToProduction'

type TransferTo = 'case' | 'production'

interface Props {
  onSourceCaseChange: (sourceCase: CaseData | null) => void
  onResetForm: () => void
}

interface State {
  transferTo: TransferTo
}

export default class QuantityTransferForm extends Component<Props, State> {
  transferToRadios: RadioGroupItem[] = [
    { name: 'case', label: 'Case' },
    { name: 'production', label: 'Production' }
  ]

  initialState: State = {
    transferTo: 'case'
  }

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
    this.handleRadioChange = this.handleRadioChange.bind(this)
  }

  get form () {
    const { onSourceCaseChange, onResetForm } = this.props
    switch (this.state.transferTo) {
      case 'case':
        return (
          <TransferToCase
            onSourceCaseChange={onSourceCaseChange}
            onResetForm={onResetForm} />
        )
      case 'production':
        return <TransferToProduction onCaseChange={onSourceCaseChange} onResetForm={onResetForm} />
    }
  }

  handleRadioChange (name: string) {
    this.setState({ transferTo: name as TransferTo })
    this.props.onResetForm()
  }

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("Quantity Transfer")}
          doc='cases-quantity-transfer-to-case' />
        <RadioGroup
          label={i18n('Transfer to')}
          radios={this.transferToRadios}
          checked={this.state.transferTo}
          onChange={this.handleRadioChange} />
        {this.form}
      </Card>
    )
  }
}
